import { ReactComponent as ViewAssessmentIcon } from 'assets/icons/ViewAssessment.svg';
import { ReactComponent as ReportIcon } from 'assets/icons/Report.svg';


const useReportDisplayBtns = () => {
    const btns = [
        {
            key: "report",
            icon: ReportIcon,
            action: () => { },
            fontSize: "small"
        },
        {
            key: "assessmentView",
            icon: ViewAssessmentIcon,
            action: () => { },
            fontSize: "small"
        }
    ]

    return btns
}

export default useReportDisplayBtns